import React, { useContext, useState } from "react";
import { ContactContext } from "../../../../../../context/contact/ContactContext";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import { ButtonCancel, ButtonUpdate, Container } from "./style";
import UpdateDialog from "../updateDialog";
import { useTranslation } from "react-i18next";

const FormDialog = ({ contactUpdate, showDialog, setShowDialog }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const { setResetPassword } = useContext(ContactContext);

  const handleClose = (e, reason) => {
    if (reason !== "backdropClick" && e.key !== "Escape") {
      setShowDialog(false);
    }
  };

  const updatePassword = async () => {
    const data = {
      guid: contactUpdate.id,
      firstName: contactUpdate.givenName,
      lastName: contactUpdate.surname,
      email: contactUpdate.mail,
      password: password,
    };
    const resp = await setResetPassword(data);
    setSuccess(true);

    setTimeout(() => {
      setShowDialogUpdate(false);
    }, 1500);
    setTimeout(() => {
      setShowDialog(false);
    }, 1500);
  };
  const submitForm = async (e) => {
    e.preventDefault();

    if (password !== "") {
      setShowDialogUpdate(true);
      await Promise.all([updatePassword()]);
    }
  };
  return (
    <div>
      {dialogUpdate ? (
        <UpdateDialog
          success={success}
          showDialogUpdate={dialogUpdate}
          setShowDialogUpdate={setShowDialogUpdate}
        />
      ) : (
        <Dialog
          open={showDialog}
          onClose={(e, reason) => handleClose(e, reason)}
        >
          <Container>
            <DialogTitle>{t("enterNewPassword")}</DialogTitle>
            <form
              onSubmit={(e) => {
                submitForm(e);
              }}
            >
              <DialogContent sx={{ alignItems: "center" }}>
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="password"
                  label={t("password")}
                  type="password"
                  fullWidth
                  variant="standard"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </DialogContent>
              <ButtonCancel onClick={handleClose}>{t("cancel")}</ButtonCancel>
              <ButtonUpdate type="submit">{t("update")}</ButtonUpdate>
            </form>
          </Container>
        </Dialog>
      )}
    </div>
  );
};
export default FormDialog;
